module.exports = __webpack_public_path__ + "img/kareha4.44a9bcd8.jpg";